(
    function (skyward, $)
    {
        "use strict";

        skyward.ajaxManager = skyward.ajaxManager || {};

        var DUPLICATE_REQUEST_HANDLING =
        {
            ABORT_PRIOR: 1,
            ABORT_NEW: 2,
            QUEUE: 3
        };

        var defaultAjaxManagerSettings =
        {
            requestsStarted: function (/* status object */)
            {
                // Called when an ajax request starts
            },
            update: function (/* status object */)
            {
                // Called when an ajax request is added or completed
            },
            requestsCompleted: function (/* status object */)
            {
                // Called when all ajax requests are completed
            },
            defaultDuplicateRequestHandling: DUPLICATE_REQUEST_HANDLING.ABORT_PRIOR
        };

        var defaultAjaxManagerRequestSettings =
        {
            requestID: null, // Used to identify ajax requests, so duplicates can be handled
            duplicateRequestHandling: null
        };

        // The ajax manager ensures that new ajax requests with the same requestID wait for existing ajax requests to finish
        // before firing. This is to prevent race conditions since we can't be certain which order the server will handle the
        // ajax requests. Requests must have a requestID attribute for this to work properly.
        skyward.ajaxManager.createAjaxManager = function (options)
        {
            var ajaxManager = {};
            var settings = $.extend({}, defaultAjaxManagerSettings, options);

            var requestTracker = (function ()
            {
                var requestTracker = {};

                var requestsInProgress = false;
                var queue = [];
                var requestsComplete = 0;

                var reset = function ()
                {
                    requestsInProgress = false;
                    queue = [];
                    requestsComplete = 0;
                };

                var getNumberOfCurrentRequests = function ()
                {
                    return requestTracker.getCurrentRequests().length;
                };

                var getStatus = function ()
                {
                    var status =
                    {
                        numberOfCurrentRequests: getNumberOfCurrentRequests(),
                        numberOfCompletedRequests: requestsComplete,
                        numberOfTotalRequests: queue.length
                    };

                    return status;
                };

                requestTracker.getCurrentRequests = function ()
                {
                    var currentRequests = [];

                    for (var i = 0; i < queue.length; i++)
                    {
                        if (queue[i].state() == "pending")
                        {
                            currentRequests.push(queue[i]);
                        }
                    }

                    return currentRequests;
                };

                requestTracker.add = function (request)
                {
                    if (!requestsInProgress)
                    {
                        requestsInProgress = true;
                        settings.requestsStarted(getStatus());
                    }

                    queue.push(request);

                    request.always(function ()
                    {
                        requestsComplete++;
                        settings.update(getStatus());

                        if (requestsComplete == queue.length)
                        {
                            settings.requestsCompleted(getStatus());
                            reset();
                        }
                    });
                };

                return requestTracker;
            })();

            var findConflictingRequestsInProgress = function (requestSettings)
            {
                var conflicts = [];

                if (requestSettings.requestID == null)
                {
                    return conflicts;
                }

                var queue = requestTracker.getCurrentRequests();

                for (var i = 0; i < queue.length; i++)
                {
                    if (queue[i]._requestID == requestSettings.requestID)
                    {
                        conflicts.push(queue[i]);
                    }
                }

                return conflicts;
            };

            var performRequest = function (ajaxSettings, requestSettings)
            {
                var deferred = $.Deferred();
                var promise;
                var conflictingRequests = findConflictingRequestsInProgress(requestSettings);
                var handleDuplicates = requestSettings.duplicateRequestHandling != null ? requestSettings.duplicateRequestHandling : settings.defaultDuplicateRequestHandling;

                if (handleDuplicates == DUPLICATE_REQUEST_HANDLING.QUEUE)
                {
                    promise = createQueuedRequest(conflictingRequests, deferred, ajaxSettings);
                }
                else if (handleDuplicates == DUPLICATE_REQUEST_HANDLING.ABORT_PRIOR)
                {
                    promise = fireRequest(deferred, ajaxSettings);
                }
                else
                {
                    if (conflictingRequests.length > 0)
                    {
                        promise = createAbortedRequest(deferred, ajaxSettings);
                    }
                    else
                    {
                        promise = fireRequest(deferred, ajaxSettings);
                    }
                }

                promise._requestID = requestSettings.requestID;
                requestTracker.add(promise);

                if (handleDuplicates == DUPLICATE_REQUEST_HANDLING.ABORT_PRIOR)
                {
                    // Abort after firing off the new request to prevent triggering requestsCompleted() prematurely.
                    for (var i = 0; i < conflictingRequests.length; i++)
                    {
                        conflictingRequests[i].abort();
                    }
                }

                return promise;
            };

            var createQueuedRequest = function (requestsToQueueAfter, deferred, ajaxSettings)
            {
                var promise = deferred.promise();
                var aborted = false;

                // This abort function is only temporary. It is only called if abort() is
                // called before the request is actually fired. It later gets replaced by the 
                // abort function created in fireRequest().
                promise.abort = function ()
                {
                    aborted = true;
                    createAbortedRequest(deferred, ajaxSettings);
                };
                                
                $.when.apply($, requestsToQueueAfter).always(function ()
                {
                    if (!aborted)
                    {
                        fireRequest(deferred, ajaxSettings);
                    }
                });
                
                return promise;
            };

            var createAbortedRequest = function (deferred, ajaxSettings)
            {
                var modifiedSettings = $.extend({}, ajaxSettings, { beforeSend: function () { return false; } });

                return fireRequest(deferred, modifiedSettings);
            };

            var fireRequest = function (deferred, ajaxSettings)
            {
                var promise = deferred.promise();
                var jqXHR = $.ajax(ajaxSettings);

                jqXHR.done(function () { deferred.resolve.apply(this, arguments); });
                jqXHR.fail(function () { deferred.reject.apply(this, arguments); });

                promise.abort = function ()
                {
                    jqXHR.abort();
                };

                return promise;
            };

            ajaxManager.ajax = function (ajaxSettings, managerRequestOptions)
            {
                var requestSettings = $.extend({}, defaultAjaxManagerRequestSettings, managerRequestOptions);

                return performRequest(ajaxSettings, requestSettings);
            };

            return ajaxManager;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);